<script>
import { forEach } from 'lodash';
import moveTextHover from '@/components/moveTextHover';

export default {
  name: 'eventList',
  components: {
    moveTextHover,
  },
  data() {
    return {
      eventList: [],
      ready: false,
    };
  },
  created() {
    const today = new Date();
    const yyyymmdd = `${today.getFullYear()}${('00' + (today.getMonth()+1)).slice(-2)}${('00' + today.getDate()).slice(-2)}`
    this.eventList = [];
    forEach(this.$t('message.information.event.events'), (v) => {
      v.done = v.yyyymmdd - yyyymmdd < 0;
      this.eventList.push(v);
    });
    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
};
</script>

<template>
  <div class="event-list" v-if="ready" :class="$mq">
    <div class="title wf-gothicfont" :title="$t('message.information.event.title')">
      {{$t('message.information.event.title')}}
    </div>
    <div
      class="event"
      v-for="event in eventList"
      :key="event.name"
      :title="event.name"
    >
      <div class="name">
        <a target="_blank" :title="event.name"
          :href="event.url"
        >
          <move-text-hover :target-text="event.name" />
          
        </a>
      </div>
      <div class="date">
        <a target="_blank" :title="event.date"
          :href="event.url"
        >
          <move-text-hover :target-text="event.date" />
          
        </a>
      </div>
      <div class="space">
        <span v-if="event.done">{{$t('message.information.event.done')}}</span>
        <a v-else target="_blank" :title="event.space"
          :href="event.url"
        >
          <move-text-hover :target-text="event.space" />
          
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .event-list {
    .title {
      font-size: 1.8em;
      text-align: center;
      margin-bottom: 30px;
    }
    .event {
      border-bottom: 1px $textColor solid;
    }
    // responsible -----------------------------------------------
    &.viewLg {
      width: 70%;
      margin: 100px auto;
      .event {
        display: flex;
        justify-content: center;
        line-height: 50px;
        .name {
          width: 40%;
        }
        .date {
          width: 20%;
        }
        .space {
          width: 40%;
        }
      }
    }
    &.viewMd {
      width: 100%;
      margin: 70px auto;
      font-size: 0.9em;
      .event {
        margin-bottom: 30px;
        display: flex;
        >div{
          margin-right: 10px;
        }
      }
    }
    &.viewSm {
      width: 100%;
      margin: 30px auto;
      height: 70%;
      font-size: 0.8em;
      .event {
        margin-bottom: 30px;
      }
    }
  }
</style>
